module.exports = __webpack_public_path__ + "media/pages/Home/images/Landing_OfficeExecutive-ed90491ab5a452015fc8899412ebdb7d.jpg";